package gay.spiders.pages

import androidx.compose.runtime.*
import com.varabyte.kobweb.browser.api
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.forms.TextInput
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.theme.SilkTheme
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import com.varabyte.kobweb.silk.theme.colors.palette.background
import gay.spiders.components.layouts.PageLayoutData
import gay.spiders.util.imageResource
import kotlinx.browser.window
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import kotlinx.serialization.Serializable
import kotlinx.serialization.encodeToString
import kotlinx.serialization.json.Json
import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Text

private const val SPIDERS_IMAGE = "/spiders.png"
private const val SPIDER_IMAGE = "/spider.png"
private const val SNEAKY_SPIDER_IMAGE = "/sneaky-spider.png"

private const val INITIAL_SPIDER_COUNT = 8000

@Serializable
private data class SignupRequest(val email: String)

@InitRoute
fun initHomePage(ctx: InitRouteContext) {
    ctx.data.add(PageLayoutData("Gay Spiders"))
}

@Page
@Layout(".components.layouts.PageLayout")
@Composable
fun HomePage() {
    Box(
        modifier = Modifier
            .fillMaxSize()
            .backgroundColor(SilkTheme.palettes[ColorMode.current].background)
            .position(Position.Relative),
        contentAlignment = Alignment.Center
    ) {
        data class SpiderPosition(val x: Int, val y: Int, val size: Int)

        val spiderPositions = remember { mutableStateListOf<SpiderPosition>() }
        val scope = rememberCoroutineScope()
        var text by remember { mutableStateOf("") }
        var showToast by remember { mutableStateOf(false) }
        var toastMessage by remember { mutableStateOf("") }
        var isErrorToast by remember { mutableStateOf(false) }

        fun addRandomSpider() {
            val imageSize = (25..75).random()
            val x = (0..(window.innerWidth - imageSize)).random()
            val y = (0..(window.innerHeight - imageSize)).random()
            spiderPositions.add(SpiderPosition(x, y, imageSize))
        }

        Column(
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Text(
                value = "Hi, I'm Kay. I'm not ${INITIAL_SPIDER_COUNT + spiderPositions.size} spiders pretending to be a person."
            )
            Spiders {
                addRandomSpider()
            }
            Text(
                value = "Want to know more about what normal human things I'm up to? Sign up for my monthly newsletter!"
            )
            Row(
                modifier = Modifier.fillMaxWidth(),
                verticalAlignment = Alignment.CenterVertically
            ) {
                TextInput(
                    text = text,
                    onTextChange = { text = it },
                    placeholder = "Enter your email address",
                    modifier = Modifier.weight(1f)
                )
                Button(
                    onClick = {
                        scope.launch {
                            val request = SignupRequest(text)
                            val body = Json.encodeToString(request).encodeToByteArray()
                            try {
                                window.api.post("signup", body = body)
                                toastMessage = "You'll hear from me soon!"
                                isErrorToast = false
                            } catch (e: Exception) {
                                if (e.message?.contains("400") == true) {
                                    toastMessage = "Please enter a valid email address"
                                } else {
                                    toastMessage = "Error: ${e.message ?: "Unknown error"}"
                                }
                                isErrorToast = true
                            }
                            showToast = true
                            text = ""
                        }
                    },
                    modifier = Modifier.margin(left = 8.px)
                ) {
                    Text("Sign Up")
                }
            }
        }

        if (showToast) {
            LaunchedEffect(toastMessage) {
                delay(3000) // Show toast for 3 seconds
                showToast = false
            }
            Box(
                modifier = Modifier
                    .position(Position.Absolute)
                    .bottom(16.px)
                    .left(50.percent)
                    .translateX((-50).percent)
                    .backgroundColor(if (isErrorToast) Color("red") else Color("green"))
                    .padding(12.px)
                    .borderRadius(8.px)
            ) {
                Text(toastMessage)
            }
        }

        spiderPositions.forEachIndexed { index, (x, y, imageSize) ->
            RandomSpider(index, x, y, imageSize)
        }
    }
}

@Composable
private fun Spiders(onClick: () -> Unit) {
    Image(
        src = imageResource(SPIDERS_IMAGE),
        alt = "A group of spiders who are NOT pretending to be a human.",
        modifier = Modifier
            .fillMaxWidth(75.percent)
            .onClick { onClick() }
    )
}

@Composable
private fun RandomSpider(index: Int, x: Int, y: Int, imageSize: Int) {
    Image(
        src = if ((0..100).random() == 0) imageResource(SNEAKY_SPIDER_IMAGE) else imageResource(SPIDER_IMAGE),
        alt = "A normal, innocent spider named Spider ${INITIAL_SPIDER_COUNT + 1 + index}.",
        modifier = Modifier
            .position(Position.Absolute)
            .left(x.px)
            .top(y.px)
            .width(imageSize.px)
    )
}
